const UEFooter = () => (
  <footer>
    <div className="footer-inner">
      <div className="footer-top">
        <div className="footer-brand">
          <div className="lockup">
            <img className="mark" src="/assets/flink-wordmark.svg" alt="Flink" />
            <span className="x">×</span>
            <img
              src="/assets/uber-eats-icon.svg"
              alt="Uber Eats"
              style={{ height: '36px', width: '36px', display: 'block' }}
            />
          </div>
          <p>
            An employed rider role in Amsterdam, Groningen and Rotterdam, exclusive to the Flink ×
            Uber Eats partnership.
          </p>
        </div>

        <div className="footer-col">
          <h4>The role</h4>
          <ul>
            <li>
              <a href="#why">What you get</a>
            </li>
            <li>
              <a href="#process">How it works</a>
            </li>
            <li>
              <a href="#compensation">Pay</a>
            </li>
            <li>
              <a href="#faq">FAQs</a>
            </li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Flink</h4>
          <ul>
            <li>
              <a href="https://www.goflink.com/">Company</a>
            </li>
            <li>
              <a href="https://riders.goflink.com/">Other rider roles</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bot">
        <span>© {new Date().getFullYear()} Flink SE. All rights reserved.</span>
        <span>
          Flink × Uber Eats is a partnership exclusive to Amsterdam, Groningen and Rotterdam.
        </span>
      </div>
    </div>
  </footer>
);

export default UEFooter;
